
angular.module('bmsApp.sm.job')
	.factory('SMMaterialTestPhotoSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

	return {
		index: function (params) {
			return CRUDSvc.get('api/sm/job/material-test-photos/index', params);
		},
	}
}]);




